import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type GetCurrentUserQueryVariables = GraphQLTypes.Exact<{
  accountId: GraphQLTypes.Scalars['String']['input'];
}>;

export type GetCurrentUserQueryResult = { __typename?: 'Query' } & {
  account?: GraphQLTypes.Maybe<
    { __typename?: 'Account' } & Pick<
      GraphQLTypes.Account,
      'organizationalRole' | 'parentAccountId' | 'referencePrefix' | 'status' | 'tradingName' | 'type'
    > & {
        businessUnits: Array<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id' | 'status' | 'tradingName' | 'type'>>;
      }
  >;
  authorization: { __typename?: 'Authorization' } & Pick<GraphQLTypes.Authorization, 'isAdmin'>;
  currentUserDetails?: GraphQLTypes.Maybe<
    { __typename?: 'AccountMember' } & Pick<
      GraphQLTypes.AccountMember,
      'email' | 'firstName' | 'hasPlatformAccess' | 'id' | 'lastName' | 'name' | 'phoneNumber'
    > & {
        account: { __typename?: 'Account' } & Pick<
          GraphQLTypes.Account,
          'id' | 'organizationalRole' | 'parentAccountId' | 'status'
        > & { ssoDetails: { __typename?: 'SsoDetails' } & Pick<GraphQLTypes.SsoDetails, 'enabled'> };
        featureFlags: Array<
          { __typename?: 'current_user_feature_flag' } & Pick<GraphQLTypes.CurrentUserFeatureFlag, 'enabled' | 'name'>
        >;
      }
  >;
};

export const GetCurrentUserDocument = gql`
  query getCurrentUser($accountId: String!) {
    account(accountId: $accountId) {
      businessUnits {
        id
        status
        tradingName
        type
      }
      organizationalRole
      parentAccountId
      referencePrefix
      status
      tradingName
      type
    }
    authorization {
      isAdmin
    }
    currentUserDetails {
      account {
        id
        organizationalRole
        parentAccountId
        ssoDetails {
          enabled
        }
        status
      }
      email
      featureFlags(accountId: $accountId) {
        enabled
        name
      }
      firstName
      hasPlatformAccess
      id
      lastName
      name
      phoneNumber
    }
  }
`;
